import { createContext, useContext, useReducer } from 'react';
import { SET_USER, DELETE_USER, LOGOUT } from '@/actions/types';

const UserContext = createContext(null);
const UserDispatchContext = createContext(null);

const initialState = null;

function userReducer(state, action) {
  switch (action.type) {
    case SET_USER: {
      return action.payload || {};
    }
    case DELETE_USER:
    case LOGOUT: {
      return initialState;
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export function UserProvider({ children }) {
  const [user, dispatch] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={user}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}

export function useUserDispatch() {
  const dispatch = useContext(UserDispatchContext);
  if (!dispatch) {
    throw new Error('useUserDispatch must be used within UserProvider');
  }
  return dispatch;
}
